module.exports = __webpack_public_path__ + "img/logo_lei_branco.a6ef2fd3.png";